<template>
  <div class="p-2 bg-white rounded-md overflow-hidden">
    <div :style="getStyle" class="paragraphScroll flex items-start justify-between">
      <span class="flex-1">
        {{ data.content }}
      </span>
      <div class="w-10">
        <span v-if="isActive" @click="openSettings">
          <i class="el-icon-s-tools" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ParagraphView',
    props: ['field', 'data', 'isActive'],
    data() {
      return {};
    },
    computed: {
      selectedValue: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
      // Tharuni Start
      getStyle() {
        return (
          `height:${this.data.height}px;width:${this.data.width}px;overflow:auto;` +
          this.getElementStyle
        );
      },
      getElementStyle() {
        let borderStyle = '';
        if (this.data.styles) {
          let type = this.data.styles.border_type ? this.data.styles.border_type : 'solid';
          let size = this.data.styles.border_size ? this.data.styles.border_size + 'px' : '0px';
          let color = this.data.styles.border_color ? this.data.styles.border_color : '';
          let font_size =
            this.data.styles && this.data.styles.font && this.data.styles.font.font_size
              ? this.data.styles.font.font_size
              : '';
          let bold =
            this.data.styles &&
            this.data.styles.font &&
            this.data.styles.font.style &&
            (this.data.styles.font.style == 1 || this.data.styles.font.style == 3)
              ? 'bold'
              : '';
          let italic =
            this.data.styles &&
            this.data.styles.font &&
            this.data.styles.font.style &&
            (this.data.styles.font.style == 2 || this.data.styles.font.style == 3)
              ? 'italic'
              : '';

          borderStyle = 'border:' + type + ' ' + ' ' + size + ' ' + color;

          borderStyle += ';';
          borderStyle += this.data.styles.background
            ? `background: ${this.data.styles.background}`
            : '';
          borderStyle += ';';
          borderStyle += 'font-size:' + font_size + 'px;';
          if (bold) {
            borderStyle += 'font-weight:' + bold + ';';
          }
          if (italic) {
            borderStyle += 'font-style:' + italic + ';';
          }
          borderStyle += this.data.styles.label_color
            ? `color: ${this.data.styles.label_color}`
            : '';
        }
        return borderStyle;
      },
      // Tharuni end
    },
    mounted() {},
    methods: {
      openSettings() {
        this.$emit('settings');
      },
    },
  };
</script>

<style lang="scss">
  .resposive-font {
    font-size: 1.2vw;
  }

  // tharuni start
  .paragraphScroll {
    height: 250px;
    overflow-y: scroll;
    overflow-x: scroll;
    border-top: 1px ridge;
    border-left: 1px ridge;
    border-bottom: 1px ridge;
    margin-right: 5px;
  }

  .paragraphScroll::-webkit-scrollbar {
    width: 0.7em;
  }

  .paragraphScroll::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    background: #e1e1e1;
    -webkit-box-shadow: inset 0 0 6px rgba(172, 169, 169, 0.9);
  }

  // thaurni end
</style>
